export const FETCH_MODELS_DATA_REQUEST = "FETCH_MODELS_DATA_REQUEST";
export const FETCH_MODELS_DATA_SUCCESS = "FETCH_MODELS_DATA_SUCCESS";
export const FETCH_MODELS_DATA_FAILURE = "FETCH_MODELS_DATA_FAILURE";

export const fetchModelsDataRequest = (thing) => {
  return {
    type: FETCH_MODELS_DATA_REQUEST,
    payload: thing,
  };
};

export const fetchModelsDataSuccess = (data) => {
  return {
    type: FETCH_MODELS_DATA_SUCCESS,
    payload: data,
  };
};

export const fetchModelsDataFailure = (error) => {
  return {
    type: FETCH_MODELS_DATA_FAILURE,
    payload: error,
  };
};
